import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useMessageFlag } from "./ExpertMessageFlagHook";
// Set the default state values for each context
export const ExpertMessageFlagContext = /*#__PURE__*/createContext({});
export const ExpertMessageFlagContextProvider = ({
  children
}) => {
  const messageFlagState = useMessageFlag();
  return /*#__PURE__*/React.createElement(ExpertMessageFlagContext.Provider, {
    value: messageFlagState
  }, children);
};
export const useExpertMessageFlagContext = () => {
  return useContext(ExpertMessageFlagContext);
};
ExpertMessageFlagContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};